import {
    deleteFile,
    getCustomerOptions,
    engineer,
    getUploadFileDetail,
    getUploadFileSign,
    postUpdateFile,
    putFiles,
    company,
    getCustomerContacts,
    publicDevices,
    getUserAccounts,
} from "@/service";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import {successMsg, errorMsg} from "@/helpers/swal";
import i18n from "@/i18n";

// 获取顾客列表， 不分页，只获取ID和name
export function getCustomers(search = '') {
    return new Promise((resolve, reject) => {
        getCustomerOptions({
            keyword: search,
            page_size: 0
        }).then(res => {
            resolve(res.payload)
        }).catch(err => {
            console.log(err)
            reject(err)
        })
    })
}

// 获取服务商
export function getCompany() {
    return new Promise((resolve, reject) => {
        company({
            page_size: 0,
            ordering: "type,name",
        }).then(res => {
            resolve(res.payload)
        }).catch(err => {
            console.log(err)
            reject(err)
        })
    })
}
// 获取工程师列表，不分页
export function getEngineer(companyId, unbind = false) {
    return new Promise((resolve, reject) => {
        engineer({
            company: companyId,
            unbind: unbind,
            page_size: 0,
        }).then(res => {
            resolve(res.payload)
        }).catch(err => {
            console.log(err)
            reject(err)
        })
    })
}

// 获取服务商下面的所有工程师账号，不分页
export function getEngineerAccountList(companyId, keyword) {
    return new Promise((resolve, reject) => {
        getUserAccounts({
            belong_id: companyId,
            belong_type: 'service_company',
            object_type: 'engineer',
            page_size: 0,
            keyword: keyword,
        }).then(res => {
            resolve(res.payload)
        }).catch(err => {
            console.log(err)
            reject(err)
        })
    })
}

// 获取客户下的所有联系人
export function getCustomerContactList(customerId) {
    return new Promise((resolve, reject) => {
        getCustomerContacts({
            customer: customerId,
            page_size: 0,
            label: '设备联系人'
        }).then(res => {
            resolve(res.payload)
        }).catch(err => {
            console.log(err)
            reject(err)
        })
    })
}

// 通过设备泵头序列号获取设备信息
export function getDeviceInfo(root_sn, withAttr = false, withExtra = false, withRepairs = false) {
    return new Promise((resolve, reject) => {
        const param = {
            root_sn: root_sn,
        }
        const fieldsTitle = {
            '设备类型': 'type',
            '开机时间': 'begin_at',
            '质保状态': 'warranty',
            '设备联系人': 'contact',
            '设备联系电话': 'contact_number',
            '设备状态': 'status',
            '所在位号': 'location',
            '详细地址': 'address',
            '设备型号': 'model'
        }
        publicDevices(param).then(res => {
            // 只取需要的字段：id name root_sn，没有root sn 的过滤掉
            const dataList = res.payload
            // console.log('设备：',dataList)
            const attributes = _.get(dataList, 'attributes', [])
            const device = {
                id: dataList.id,
                name: dataList.name,
                files: dataList.files,
                product_type: dataList.product_type,
                root_sn: dataList.root_sn,
                group_sn: dataList.group_sn,
                root_sn_list: dataList.root_sn_list,
            }
            if (dataList.product_type == 1) {
                device.product_type_txt = i18n.global.t('page.work-order.device.single')
            } else {
                device.product_type_txt = i18n.global.t('page.work-order.device.unit_type')
            }

            for (let i = 0; i < attributes.length; i++) {
                if (['设备出厂信息', '设备管理信息'].includes(attributes[i].group) && attributes[i].name in fieldsTitle) {
                    let title = attributes[i].name
                    device[fieldsTitle[title]] = attributes[i].value
                }
            }
            if (withAttr) {
                device.attributes = attributes
            }
            if (withExtra) {
                device.extra_info = dataList.extra_info
            }
            if (withRepairs) {
                device.repairs = dataList.repairs
            }
            resolve(device)
        }).catch(err => {
            console.log('设备查询失败', err)
            reject(err)
        })
    })

}

// 上传或删除文件
export function updateFiles(file, type, prefix = '', showMsg = true) {
    return new Promise((resolve, reject) => {
        if (type == "add") {
            if (!prefix) {
                reject('prefix is needed when upload file')
            }
            let filename = file.name;
            let objectName = `${prefix}/${uuidv4()}/${filename}`;
            let signParams = {
                object: objectName,
                method: "upload",
            };
            getUploadFileSign(signParams).then((sign) => {
                if (sign && sign.payload) {
                    putFiles(sign.payload.signedUrl, file, file.type).then(() => {
                        let detailOption = {
                            object: objectName,
                        };
                        getUploadFileDetail(detailOption).then((detail) => {
                            if (detail && detail.payload) {
                                let info = {
                                    url: detail.payload.url,
                                    etag: detail.payload.etag,
                                    size: detail.payload.size,
                                    content_type: detail.payload.contentType,
                                    object_name: detail.payload.objectName,
                                    last_modified: detail.payload.lastModified,
                                };
                                postUpdateFile(info).then((post) => {
                                    if (post && post.payload) {
                                        let file = _.cloneDeep(post.payload);
                                        file.name = filename;
                                        if (showMsg) {
                                            successMsg(i18n.global.t('base.upload_success'))
                                        }
                                        resolve(file)
                                    } else {
                                        if (showMsg) {
                                            errorMsg(i18n.global.t('base.delete_failed_please_try_again'))
                                        }
                                        reject(post)
                                    }
                                });
                            }
                        });
                    });
                }
            });
        } else {
            let params = { object: file.object_name };
            deleteFile(params).then((res) => {
                if (res && res.payload) {
                    resolve(true)
                } else {
                    reject(res)
                }
            });
        }
    })
}
